// src/pages/NotFound.jsx
import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="text-center">
        <h1 className="text-5xl sm:text-6xl font-bold mb-4">404</h1>
        <p className="text-lg sm:text-xl mb-4">Página no encontrada.</p>
        <Link to="/" className="text-blue-600 hover:underline text-base sm:text-lg">
          Volver al inicio
        </Link>
      </div>
    </div>
  );
}

export default NotFound;
